import React from "react";

import { Formik } from "formik";

import credentialingDashboardApi from "apis/credentialingDashboard";

import EditForm from "./EditForm";

const Edit = ({
  data,
  searchParams,
  isViewMode,
  userPermissions,
  updateData,
}) => {
  const handleSave = async values => {
    try {
      await credentialingDashboardApi.update(
        searchParams.credentialing_dashboard.npi,
        values
      );
      updateData(searchParams.credentialing_dashboard);
    } catch (err) {
      logger.log(err);
    }
  };

  return (
    <Formik
      validateOnChange
      initialValues={JSON.parse(JSON.stringify(data).replaceAll("null", '""'))}
      onSubmit={handleSave}
    >
      <EditForm
        data={data}
        isViewMode={isViewMode}
        userPermissions={userPermissions}
        searchParams={searchParams}
      />
    </Formik>
  );
};

export default Edit;
